var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "g",
    {
      class: [
        "arrow-marker-group",
        { "arrow-marker-group--rotating": _vm.rotating },
      ],
      attrs: { "aria-label": _vm.ariaLabel },
    },
    [
      !_vm.isExporting
        ? [
            _c("line", {
              staticClass: "rotation-stem-hitarea",
              attrs: {
                "data-testid": "rotation-stem-hitarea",
                x1: _vm.x,
                y1: _vm.y,
                x2: _vm.stemEndX,
                y2: _vm.stemEndY,
                stroke: "transparent",
                "stroke-width": 12 * _vm.sizeScale,
              },
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "rotation-stem",
              attrs: {
                "data-testid": "rotation-stem",
                x1: _vm.x,
                y1: _vm.y,
                x2: _vm.stemEndX,
                y2: _vm.stemEndY,
                stroke: "#333",
                "stroke-width": 1.5 * _vm.sizeScale,
              },
            }),
            _vm._v(" "),
            _c("circle", {
              staticClass: "rotation-handle",
              attrs: {
                "data-testid": "rotation-handle",
                cx: _vm.stemEndX,
                cy: _vm.stemEndY,
                r: _vm.handleRadius,
                fill: _vm.color,
                stroke: "black",
                "stroke-width": 2 * _vm.sizeScale,
              },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                  return _vm.$emit("rotation-start", $event)
                },
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "g",
        _vm._g(
          {
            staticClass: "arrow-shape",
            attrs: { transform: _vm.arrowTransform },
          },
          _vm.$listeners
        ),
        [
          _c(
            "svg",
            {
              attrs: {
                x: -_vm.markerSize / 2,
                y: -_vm.markerSize / 2,
                width: _vm.markerSize,
                height: _vm.markerSize,
                viewBox: _vm.VIEWBOX,
              },
            },
            [
              _c("path", {
                attrs: {
                  "data-testid": "arrow-marker-shape",
                  d: _vm.PATH,
                  fill: _vm.color,
                  stroke: "black",
                  "stroke-width": _vm.STROKE_WIDTH,
                },
              }),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }